// import React from "react";
// import { Pagination, PaginationItem, PaginationLink } from "reactstrap";

// const CustomPagination = ({
//   totalItems,
//   itemsPerPage,
//   currentPage,
//   onPageChange,
// }) => {
//   const totalPages = Math.ceil(totalItems / itemsPerPage);

//   const handlePageClick = (page) => {
//     if (page >= 1 && page <= totalPages) {
//       onPageChange(page);
//     }
//   };

//   const pageNumbers = [];
//   for (let i = 1; i <= totalPages; i++) {
//     pageNumbers.push(i);
//   }

//   return (
//     <Pagination className="justify-content-center mt-4">
//       <PaginationItem disabled={currentPage === 1}>
//         <PaginationLink first onClick={() => handlePageClick(1)} />
//       </PaginationItem>
//       <PaginationItem disabled={currentPage === 1}>
//         <PaginationLink previous onClick={() => handlePageClick(currentPage - 1)} />
//       </PaginationItem>
//       {pageNumbers.map((page) => (
//         <PaginationItem active={currentPage === page} key={page}>
//           <PaginationLink onClick={() => handlePageClick(page)}>
//             {page}
//           </PaginationLink>
//         </PaginationItem>
//       ))}
//       <PaginationItem disabled={currentPage === totalPages}>
//         <PaginationLink next onClick={() => handlePageClick(currentPage + 1)} />
//       </PaginationItem>
//       <PaginationItem disabled={currentPage === totalPages}>
//         <PaginationLink last onClick={() => handlePageClick(totalPages)} />
//       </PaginationItem>
//     </Pagination>
//   );
// };

// export default CustomPagination;

import React from "react";
import { Pagination, PaginationItem, PaginationLink } from "reactstrap";

const CustomPagination = ({
  totalItems,
  itemsPerPage,
  currentPage,
  onPageChange,
}) => {
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  const handlePageClick = (page) => {
    if (page >= 1 && page <= totalPages) {
      onPageChange(page);
    }
  };

  // Calculate the range of pages to display
  const maxVisiblePages = 3; // Number of page links to show
  const startPage = Math.max(currentPage - 1, 1); // Start range
  const endPage = Math.min(startPage + maxVisiblePages - 1, totalPages); // End range

  const pageNumbers = [];
  for (let i = startPage; i <= endPage; i++) {
    pageNumbers.push(i);
  }

  return (
    <Pagination className="justify-content-left mt-4">
      {/* First and Previous Buttons */}
      <PaginationItem disabled={currentPage === 1}>
        <PaginationLink first onClick={() => handlePageClick(1)} />
      </PaginationItem>
      <PaginationItem disabled={currentPage === 1}>
        <PaginationLink previous onClick={() => handlePageClick(currentPage - 1)} />
      </PaginationItem>

      {/* Page Numbers */}
      {pageNumbers.map((page) => (
        <PaginationItem active={currentPage === page} key={page}>
          <PaginationLink onClick={() => handlePageClick(page)}>
            {page}
          </PaginationLink>
        </PaginationItem>
      ))}

      {/* Next and Last Buttons */}
      <PaginationItem disabled={currentPage === totalPages}>
        <PaginationLink next onClick={() => handlePageClick(currentPage + 1)} />
      </PaginationItem>
      <PaginationItem disabled={currentPage === totalPages}>
        <PaginationLink last onClick={() => handlePageClick(totalPages)} />
      </PaginationItem>
    </Pagination>
  );
};

export default CustomPagination;
